import styles from './style.module.scss';
import classNames from 'classnames';
function Switch2({ active, handleCLick, containerStyle, themeClass }) {
    return (
        <div className={classNames('d-flex align-items-center', containerStyle && containerStyle)}>
            <label class={classNames(styles.switch)}>
                <input type="checkbox" checked={active} onClick={handleCLick} />
                <span id="slider" class={classNames(styles.slider, styles.round, `${themeClass}BorderColor`)}></span>
            </label>
        </div>
    );
}

export default Switch2;
